import { SearchIcon } from "@icons/SearchIcon";
import React, { useState } from "react";
import { ContentSearchModal } from "./ContentSearchModal";
import { useGroupSelector } from "../../GroupSelector/useGroupSelector";
import { SearchSectionStack, SearchTypography } from "./EntrypointFeed.styles";

export function EntrypointFeed() {
    const [open, setOpen] = useState(false);
    const { filters } = useGroupSelector();

    return (
        <>
            <SearchSectionStack onClick={() => setOpen(true)}>
                <SearchIcon width="16px" height="16px" />
                <SearchTypography>Suchen</SearchTypography>
            </SearchSectionStack>
            {filters && (
                <ContentSearchModal
                    onClose={() => setOpen(false)}
                    open={open}
                    groupIds={filters.map(Number)}
                />
            )}
        </>
    );
}
